import React, { Component, Fragment } from "react";
import { Link } from 'react-router-dom';

import Content from "../../components/Content/ContentPage/Content";
import ContentHeader from "../../components/Content/ContentHeader/ContentHeader";
import Card from "../../components/Card/Card";
import MessageHandler from "../../components/MessageHandler/MessageHandler";
import { required, length } from "../../util/validators";
import Loader from "../../components/Loader/Loader";
import ErrorHandler from "../../components/ErrorHandler/ErrorHandler";
import BrandForm from "../../components/Brand/BrandForm/BrandForm";
import Paginator from '../../components/Paginator/Paginator';
import VariantForm from '../../components/Variant/VariantForm/VariantForm'
import EditVariant from '../../components/Variant/EditVariant/EditVariant'
import AttributesContainer from '../../components/Variant/AttributesContainer/AttributesContainer'

import "./Test3.css";

const POST_FORM = {
  title: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 2 })],
  },
  enTitle: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 2 })],
  },
  description: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 70 })],
  },
  origin: {
    value: 0,
    valid: true,
    touched: true,
    errorMessage: "",
    validators: [],
  },
  image: {
    value: "",
    valid: true,
    touched: true,
    errorMessage: "",
    validators: [required],
  },
  categoryCode: {
    value: 0,
    valid: true,
    touched: true,
    errorMessage: "",
    validators: [],
  },
};

class Test3 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditSection: false,

      tableData: [],
      active: false,
      showMessage: false,
      code: 0,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
      
    };
  }

  toggleVariantClass = () => {
    this.setState({
      isEditSection: this.state.isEditSection ? false : true,
    });
  };

  
  toggleClass() {
    this.setState({
      active: this.state.active ? false : true,
      isEditing: false,
      editingData: {}
    });
  }

  onDeleteBrandHandler = (data) => {
    const Index = this.props.tableData.findIndex((p) => p.code === data.code);

    this.setState({
      code: data.code,
      showMessage: true,
      label: data.label,
      title: this.props.tableData[Index].title,
    });
  };

  onEditBrandHandler = (data) => {
    const Index = this.props.tableData.findIndex((p) => p.code === data.code);  
    
    this.setState({
      active: true,
      isEditing: true,
      editingData: this.props.tableData[Index]
    });

    // this.props.onEditHandler.bind(this, {
    //   code: this.state.code,
    //   label: this.state.label,
    // });
  };

  onCancelBrandHandler = () => {
    this.setState({
      code: 0,
      showMessage: false,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
    });
  };
  onDeleteBrandTypeDicisionHandler = () => {
      this.props.onDeleteDataHandler({
      code: this.state.code,
      label: this.state.label,
    });
    this.setState({
      code: 0,
      showMessage: false,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
    });    
  };


  onEditHandler = () => {
    this.setState({
      isEditing: true,
    });
  };
  onDeleteHandler = (data) => {
      const graphqlQuery = {
        query: `
        mutation {
          deleteBrand(code: ${parseInt(data.code)})
        }
      `,
      };
      fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this.props.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(graphqlQuery),
      })
        .then((res) => {
          return res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            throw new Error("Deleting the post failed!");
          }
          // this.newResetHandler();
          this.setState((prevState) => {
            let updatedPosts = [...prevState.brand];
            const postIndex = prevState.brand.findIndex(
              (p) => p.code === data.code
            );
            if (postIndex > -1) {
              updatedPosts.splice(postIndex, 1);
            }

            return {
              brand: updatedPosts,
            };
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ categoriesLoading: false });
        });        
  };

  onQueryHandler = (tab) => {
    const graphqlQuery = {
        query: `
        query FetchBrands($categoryCode: Int) {
            brands(categoryCode: $categoryCode){
            code
            title
            enTitle
            imageUrl
            description
            origin
            isActive
            }
        }
        `,
        variables: {
        categoryCode: this.state.parentCode.code,
        },
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت اطلاعات!");
        }

        this.setState({
            brand: resData.data.brands,
        });
           
      })
      .catch(this.catchError);
  };

  acceptBrandChangeHandler = (postData) => {
    this.setState({
      editLoading: true,
    });
    const formData = new FormData();
    formData.append("image", postData.image);
    if (postData.oldImageUrl !== "") {
      formData.append("oldPath", postData.oldImageUrl);
    }
    fetch("http://localhost:8080/post-image", {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + this.props.token,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((fileResData) => {
        const imageUrl = fileResData.filePath || "undefined";
        let graphqlQuery;
        if (postData.editingCode !== 0) {
          if (postData.label === " برند") {
            graphqlQuery = {
              query: `
                mutation updatedBrand($code: Int!, $categoryCode: Int!, $title: String!, $enTitle: String!, $imageUrl: String!, $description: String!, $origin: Boolean!) {
                  updateBrand(code: $code, brandInput: {categoryCode: $categoryCode, title: $title, enTitle: $enTitle, imageUrl: $imageUrl, description: $description, origin: $origin}) {
                    code
                    title
                    enTitle
                    imageUrl
                    description
                    origin
                    isActive
                  }
                }
              `,
              variables: {
                code: postData.editingCode,
                categoryCode: postData.categoryCode,
                title: postData.title,
                enTitle: postData.enTitle,
                description: postData.description,
                origin: postData.origin,
                imageUrl: imageUrl,
              },
            };
          }
        } else {
          if (postData.label === " برند") {
            graphqlQuery = {
              query: `
                mutation createNewBrand($categoryCode: Int!, $title: String!, $enTitle: String!, $imageUrl: String!, $description: String!, $origin: Boolean!) {
                  createBrand(brandInput: {categoryCode: $categoryCode, title: $title, enTitle: $enTitle, imageUrl: $imageUrl, description: $description, origin: $origin}) {
                    code
                    title
                    enTitle
                    imageUrl
                    description
                    origin
                    isActive
                  }
                }
              `,
              variables: {
                categoryCode: postData.categoryCode,
                title: postData.title,
                enTitle: postData.enTitle,
                description: postData.description,
                origin: postData.origin,
                imageUrl: imageUrl,
              },
            };
          }          
        }     

        return fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
          method: "POST",
          body: JSON.stringify(graphqlQuery),
          headers: {
            Authorization: "Bearer " + this.props.token,
            "Content-Type": "application/json",
          },
        });
      })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors && resData.errors[0].status === 422) {
          throw new Error(
            "Validation failed. Make sure the email address isn't used yet!"
          );
        }
        if (resData.errors) {
          throw new Error("ورود کاربر ناموفق!");
        }

        let resDataField = "createBrand";
        if (postData.editingCode !== 0) {
          resDataField = "updateBrand";          
        }

        var post = {
          code: resData.data[resDataField].code,
          title: resData.data[resDataField].title,
          enTitle: resData.data[resDataField].enTitle,
          imageUrl: resData.data[resDataField].imageUrl,
          description: resData.data[resDataField].description,
          origin: resData.data[resDataField].origin,
          isActive: resData.data[resDataField].isActive,
        };

        this.setState((prevState) => {
            
            let updatedPosts = [...prevState.brand];
            if (postData.editingCode !== 0) {
              const postIndex = prevState.brand.findIndex(
                (p) => p.code === post.code
              );
              updatedPosts[postIndex] = post;
            } else {
              updatedPosts.unshift(post);
            }
            return {
              brand: updatedPosts,
            };
          
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isEditing: false,
          editBrand: false,
          editLoading: false,
          error: err,
        });
      });
  };

  

  errorHandler = () => {
    this.setState({ error: null });
  };

  catchError = (error) => {
    this.setState({ error: error });
  };

  render() {
    return (
      <Fragment>
        <ErrorHandler error={this.state.error} onHandle={this.errorHandler} />
        <MessageHandler
          showMessage={this.state.showMessage}
          onHandle={this.onCancelBrandHandler}
          message={
            "آیا می‌خواهید " +
            this.state.label +
            ' کالایی "' +
            this.state.title +
            '" را حذف کنید؟'
          }
          onCancelModal={this.onCancelBrandHandler}
          onAcceptModal={this.onDeleteBrandTypeDicisionHandler}
          acceptMessage="تایید"
          cancelMessage="لغو"
        />
        <Content>
            <ContentHeader
              headerAction="درج تنوع"
              headerDescription="نتوع کالاها را در این صفحه وارد کنید"
            />
            <Card> 
               <div className="mn-grid__row">
                    <div className="mn-grid__col">
                        <div className="mn-variant">
                            <form className="mn-variant__form" id="productVariantsForm" data-max-variants="" novalidate="novalidate">
                                <input type="hidden" name="product_variants[product_id]" value="530113"/>
                                <input type="hidden" name="product_variants[variation_theme]" value="no_color_no_size"/>
                                <div className="c-content-modal__notes"> <span className="c-content-modal__notes-title">توجه:</span>
                                    <ul className="c-content-modal__notes-list">
                                        <li>لطفاً قبل از درج تنوع، مشخصات فنی کالا (مانند: رنگ، ابعاد، اقلام همراه کالا، جنس کالا، تصویر بسته‌بندی و ...) را در سایت چک کرده و اطمینان حاصل کنید که تنوع شما با مشخصات فنی کالا در سایت مطابقت داشته باشد. عدم تطابق مشخصات فنی کالا با تنوع شما، علاوه بر ایجاد نارضایتی مشتریان و تاثیر در امتیاز عملکرد شما، موجب مرجوع شدن سفارشات به علت مغایرت شده و همچنین موجب غیر‌فعال شدن کالا/گروه کالایی خواهد شد.</li>
                                    </ul>
                                </div>
                                <div className="mn-variant-error mn-variant-error__box mt-20 mb-20 hidden"></div>
                                <div className="mn-variant__header">
                                    <div className="mn-variant__img-container">
                                        <img src="https://dkstatics-public.digikala.com/digikala-products/2525920.jpg?x-oss-process=image/resize,m_fill,h_120,w_120" alt="" className="mn-variant__img"/>
                                    </div>
                                    <div className="mn-variant__descr">
                                        <h2 className="mn-variant__title">کارت حافظه microSDHC ویکو من مدل Extre600X کلاس 10 استاندارد UHS-I U3 سرعت 90MBps ظرفیت 32گیگابایت همراه با آداپتور SD</h2>
                                        <div className="mn-variant__sub-title"></div>
                                        <div className="mn-variant__secondary-info mn-variant__secondary-info--top">
                                            <ul className="mn-variant__secondary-info--table">
                                                <li className="mn-variant__secondary-info--table-row">
                                                    <div className="mn-variant__secondary-info--table-cell"> <span className="mn-variant__info">دسته بندی:</span>
                                                        <span className="mn-variant__info--main">کارت حافظه</span>
                                                    </div>
                                                    <div className="mn-variant__secondary-info--table-cell"> <span className="mn-variant__info">تنوع مجاز این کالا:</span>
                                                        <span className="mn-variant__info--main">بدون رنگ یا سایز</span>
                                                    </div>
                                                    {/* <div className="mn-variant__secondary-info--table-cell"> <span className="mn-variant__info">کمیسیون فروش این کالا:</span>
                                                        <span className="mn-variant__info--main">۳٪</span>
                                                    </div> */}
                                                </li>
                                                <li className="mn-variant__secondary-info--table-row">
                                                    <div className="mn-variant__secondary-info--table-cell"> <span className="mn-variant__info">ابعاد بسته‌بندی محصول (ارتفاع×عرض×طول):</span>
                                                        <span className="mn-variant__info--main">۱۴x۱۰x۱ سانتیمتر</span>
                                                    </div>
                                                    <div className="mn-variant__secondary-info--table-cell"> <span className="mn-variant__info">وزن بسته‌بندی محصول:</span>
                                                        <span className="mn-variant__info--main">۲۰ گرم</span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div> 
                                <div className="mn-variant__body" data-select2-id="26">
                                  <AttributesContainer/>
                                    <div className="mn-variant-error mn-variant-error__box mt-20 mb-20 hidden" id="ajaxErrorsList"></div>
                                    <div className="mn-variant-success mn-variant-success__box mt-20 mb-20" id="ajaxSuccessList">
                                        <div>تنوع‌های شما با موفقیت ذخیره شدند</div>
                                    </div>
                                    <div className="mn-grid__row mn-grid__row--gap-lg mt-30">
                                        <VariantForm
                                        warranties={[]}/>
                                    </div>
                                    <div className="mn-grid__row mn-grid__row--gap-lg">
                                        <div className="mn-grid__col mn-grid__col--gap-lg">
                                            <button type="button" className="c-ui-btn c-ui-btn--dkpc hidden" id="saveNewVariantsButton">افزودن به لیست تنوع</button>
                                            <button type="button" className="c-ui-btn c-ui-btn--add c-ui-btn--dkpc js-add-variant">افزودن تنوع جدید</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div className="mn-variant__form" id="productVariantsContainer">
                                <input type="hidden" className="js-static-form-data" name="search[product_id]" value="530113"/>
                                <div className="mn-grid__row js-table-container">
                                    <div className="mn-grid__col">
                                        <div className="c-variation-diversity">
                                            <div className="c-variation-diversity__header">
                                                <div className="c-variation-diversity__title">لیست تنوع ها</div>
                                                <Paginator
                                                    onNext={this.onEditHandler.bind(this)}
                                                    lastPage={Math.ceil(this.state.totalBrands / this.state.perPage)}
                                                    totalBrands={this.state.totalBrands}
                                                    currentPage={this.state.brandPage}
                                                />
                                            </div>
                                            <div className="c-variation-diversity__list">
                                                <table className="c-ui-table   js-search-table " data-sort-column="product_variant_id" data-sort-order="desc" data-search-url="/content/create/product/variant/search/" data-auto-reload-seconds="0" data-new-ui="1" data-is-header-floating="1" data-has-checkboxes="">
                                                    <thead>
                                                        <tr className="c-ui-table__row">
                                                            <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column">ردیف</span>
                                                            </th>
                                                            <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column">عنوان تنوع کالا</span>
                                                            </th>
                                                            <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column">عنوان گارانتی</span>
                                                            </th>
                                                            <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column">کد تنوع (SHPC)</span>
                                                            </th>
                                                            {/* <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column">کد فروشنده</span>
                                                            </th> */}
                                                            {/* <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column">ارسال توسط</span>
                                                            </th>
                                                            <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column">کانال فروش</span>
                                                            </th> */}
                                                            <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column">فعال / غیرفعال</span>
                                                            </th>
                                                            <th className="c-ui-table__header c-ui-table__header--nowrap "> <span className="js-search-table-column"></span>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr 
                                                        className={[
                                                            "c-variation-diversity__item c-variation-diversity__item--top",
                                                            `${this.state.isEditSection && "edit"}`,
                                                          ].join(" ")}
                                                        id="productVariantViewRow_22424206">
                                                            <td className="c-variation-diversity__count">۱</td>
                                                            <td className="c-variation-diversity__title"></td>
                                                            <td className="c-variation-diversity__warranty">گارانتی 36 ماهه نوین رایانه سگال</td>
                                                            <td className="c-variation-diversity__code">22424206</td>
                                                            {/* <td className="c-variation-diversity__code js-view-supplier-code"></td> */}
                                                            {/* <td>
                                                                <div className="uk-flex"> <span className="c-variation-diversity__channel dk js-view-shipping-type-digikala active"></span>
                                                                    <span className="c-variation-diversity__channel seller js-view-shipping-type-seller"></span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="uk-flex"> <span className="c-variation-diversity__channel dk js-view-site-digikala active"></span>
                                                                    <span className="c-variation-diversity__channel ds js-view-site-digistyle"></span>
                                                                </div>
                                                            </td> */}
                                                            <td className="c-variation-diversity__status js-view-active"> <span className="c-variation-diversity__status-ui js-td-active active"></span>
                                                            </td>
                                                            <td className="c-variation-diversity__action">
                                                                <button type="button" className="uk-padding-remove mn-product_link" to="/product/edit/6582800/" onClick={this.toggleVariantClass}>
                                                                    <div className="c-mega-campaigns-join-list__container-table-btn c-mega-campaigns-join-list__container-table-btn--small-edit c-ui--mr-10 js-tool-tip-desc" aria-expanded="false"></div>
                                                                    <div className="c-rating-chart__description-tooltip c-mega-campaigns-join-list__container-table-btn-tooltip uk-text-nowrap uk-dropdown uk-dropdown-stack" uk-dropdown="boundary: .js-tool-tip-desc; pos: bottom-center;delay-hide: 0;offset: 10;" style={{left: '89.4px', top: '82.5333px'}}>ویرایش محصول</div>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        <tr
                                                        className={[
                                                            "c-variation-diversity__item c-variation-diversity__item--bottom",
                                                            `${this.state.isEditSection && "edit"}`,
                                                          ].join(" ")}
                                                        id="productVariantEditRow_22424206" 
                                                        data-size="">
                                                            <td colspan="9">
                                                                <EditVariant
                                                                toggleVariantClass={this.toggleVariantClass.bind(this)}/>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="c-variation-diversity__footer">
                                                <Paginator
                                                    onNext={this.onEditHandler.bind(this)}
                                                    lastPage={Math.ceil(this.state.totalBrands / this.state.perPage)}
                                                    totalBrands={this.state.totalBrands}
                                                    currentPage={this.state.brandPage}
                                                />
                                            </div>
                                            <div className="c-card__loading"></div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="c-content-loader">
                                    <div className="c-content-loader__logo"></div>
                                    <div className="c-content-loader__spinner"></div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </Content>
      </Fragment>
    );
  }
}

export default Test3;

